import React from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../../resource/image/clabil-logo.png';
import youtube from '../../resource/image/youtube.png';

const Footer = () => {
  const navigate = useNavigate();

  const handleYouTubeClick = () => {
    window.open(
      'https://youtube.com/channel/UCQ1KeVSwHwJgsDcz_UQFDIw',
      '_blank',
      'noopener, noreferrer'
    );
  };

  return (
    <footer className="w-full bg-clabil-bg-secondary border-t border-clabil-border-light font-pretendard">
      <div className="container mx-auto py-8 md:py-12">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-8">
          {/* 회사 정보 */}
          <div className="flex-1 text-clabil-text-secondary">
            {/* 로고 */}
            <img
              src={logo}
              alt="CLABIL Logo"
              className="h-10 md:h-12 w-auto mb-4 cursor-pointer hover:opacity-80 transition-opacity"
              onClick={() => navigate('/')}
            />

            {/* CEO & 사업자등록번호 */}
            <div className="flex flex-col sm:flex-row gap-2 sm:gap-5 mb-2 text-sm">
              <div>CEO 최상천</div>
              <div>Business Registration 367-81-02254</div>
            </div>

            {/* 주소 */}
            <div className="mb-2 text-sm">서울특별시 송파구 법원로11길 11, B동 511호(문정현대지식산업센터)
            </div>

            {/* 연락처 */}
            <div className="flex flex-col lg:flex-row gap-2 lg:gap-5 mb-4 text-sm">
              <div>E-mail : sc.choi@clabil.com</div>
              <div className="hidden lg:block text-clabil-text-tertiary">|</div>
              <div>Tel : 02-400-1105</div>
              <div className="hidden lg:block text-clabil-text-tertiary">|</div>
              <div>Fax : 02-400-1106</div>
            </div>

            {/* Copyright */}
            <div className="text-sm text-clabil-text-tertiary">
              Copyright © CLABIL Corp. Ltd. All Rights Reserved.
            </div>
          </div>

          {/* YouTube 링크 */}
          <div className="flex items-center justify-center md:justify-end shrink-0">
            <button
              onClick={handleYouTubeClick}
              className="flex items-center justify-center"
              aria-label="Visit our YouTube channel"
            >
              <img
                src={youtube}
                alt="YouTube"
                className="w-10 h-10 md:w-12 md:h-12 shrink-0 object-contain"
              />
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
